<template>
  <div class="fullWidth fRow jBetween aCenter wrap formSection"
    style="padding: 16px !important"
    v-bind:class="{done: isNewPaymentReady}">
    <!-- v-bind:class="{done: isNewPaymentReady}"> -->
    <div class="fullWidth">
      <date-picker
        v-model="payDate"
        type="datetime"
        :element="`payDates${i}`"/>
      <date-picker
        v-model="checkDate"
        :element="`checkDates${i}`"/>
    </div>
    <!-- Radio -->
    <div class="fullWidth fRow jStart aCenter wrap"
      v-if="!noQest"
      style="padding: 0 8px 8px 8px; margin-bottom: 16px">
      <div class="ti fullWidth jStart aCenter">ابتدا نوع آیتم پرداختی را انتخاب کنید</div>
      <radio
        v-for="(item, index) in payTypes" v-bind:key="index"
        :simple="true"
        :data="item"
        style="padding-left: 24px"
        :selected="item.id === payType"
        @click.native="payType = item.id" />
    </div>
    <!-- qest list -->
    <div class="fullWidth fRow jBetween aStart qests wrap"
      v-if="payType === 1">
      <radio
        v-for="(item, index) in qests"
        v-bind:key="index"
        :simple="true"
        :data="item"
        :hasSlot="true"
        class="fullWidth"
        style="padding-left: 24px"
        :selected="item.id === selectedQest"
        @click.native="selectedQest = item.id">
        <div class="fRow jStart aCenter fullWidth qest"
          v-bind:class="{
            selected: item.id === selectedQest
          }">
          <div class="ind">{{index + 1}}</div>
          <div class="amount fRow jCenter aCenter">
            <span class="a">{{commaSep(item.amount)}}</span>
            <div class="unit">تومان</div>
          </div>
          <div class="growFull fCol jCenter aStart">
            <div class="qestTitle">قسط شماره‌ی {{index + 1}}</div>
            <div class="qestDate">{{formatDate(item.date)}}</div>
          </div>
          <div class="qestState">
            {{item.recived ? 'پرداخت شده' : 'پرداخت نشده'}}
          </div>
        </div>
      </radio>
    </div>
    <div class="w25 fCol jStart aStart inputHolder">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: payMethodErr}">account_balance_wallet</i>
        نحوه پرداخت</span>
        <cool-select
          class="fullWidth"
          @select="selected($event, 'payMethod')"
          disable-search
          v-model="payMethod"
          :placeholder="payMethod !== ''
              ? '' : 'نحوۀ پرداخت'"
          :items="payMethods"
          :item-value="payMethods.id"
          :item-text="payMethods.title">
          <!-- slot for each item in the menu -->
          <template slot="item" slot-scope="{ item: payMethods }">
            <div style="display: flex; align-items: center;">
              <div>
                {{ payMethods.title }}
              </div>
            </div>
          </template>
          <!-- slot for the selected item (in the text field) -->
          <template slot="selection" slot-scope="{ item: payMethods }">
            <div>
              {{ payMethods.title }}
            </div>
          </template>
        </cool-select>
    </div>
    <div class="w25 fCol jStart aStart inputHolder">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: payAccountErr}">account_balance_wallet</i>
        به حساب</span>
        <cool-select
          class="fullWidth"
          @select="selected($event, 'payAccount')"
          disable-search
          v-model="payAccount"
          :placeholder="payAccount !== '' ? '' : 'به حساب'"
          :items="payAccounts"
          :item-value="payAccounts.id"
          :item-text="payAccounts.title">
          <!-- slot for each item in the menu -->
          <template slot="item" slot-scope="{ item: payAccounts }">
            <div class="fCol jCenter aStart">
              <div>
                {{ payAccounts.title }}
              </div>
              <div style="font-size: 10px;
                padding: 2px 6px;
                border-radius: 8px; background-color: #00000015"
                >{{payAccounts.bank}}</div>
            </div>
          </template>
          <!-- slot for the selected item (in the text field) -->
          <template slot="selection" slot-scope="{ item: payAccounts }">
            <div>
              {{ payAccounts.title }}
            </div>
          </template>
        </cool-select>
    </div>
    <div class="w25 fCol jStart aStart inputHolder">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: payDateErr}">date_range</i>
        تاریخ پرداخت</span>
      <div class="fRow jStart aCenter fullWidth inputWraper"
        style="margin-bottom: 0px">
        <input :id="`payDates${i}`"
          disabled
          class="transition-fast" placeholder="تاریخ پرداخت"
          type="text" v-model="payDateShow">
      </div>
    </div>
    <div class="w25 fCol jStart aStart inputHolder">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: payAmountErr}">payments</i>
        مبلغ (تومان)</span>
      <div class="fRow jStart aCenter fullWidth inputWraper"
        style="margin-bottom: 0px">
        <input @keyup.enter="newPayment"
          class="transition-fast" placeholder="مبلغ (تومان)"
          type="text" v-model="payAmount">
      </div>
    </div>
    <!-- شماره حساب واریز کننده برای پرداخت حساب به حساب -->
    <div class="fCol jStart aStart inputHolder w50" v-if="payMethod.id === 4">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: depositorErr}">credit_card</i>
        شماره حساب واریز کننده</span>
      <div class="fRow jStart aCenter fullWidth inputWraper">
        <input
          class="transition-fast" placeholder="شماره حساب واریز کننده"
          type="number" v-model="depositor">
      </div>
    </div>
    <!-- چهار رقم آخر شماره کارت واریز کننده  برای پرداخت کارت به کارت -->
    <div class="fCol jStart aStart inputHolder w50" v-if="payMethod.id === 2">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: lastFourDigitsErr}">description</i>
        چهار رقم آخر شماره کارت واریز کننده</span>
      <div class="fRow jStart aCenter fullWidth inputWraper">
        <input
          class="transition-fast" placeholder="چهار رقم آخر شماره کارت واریز کننده"
          type="text" v-model="lastFourDigits">
      </div>
    </div>
    <!--  کد رهگیری اختیاری برای حساب به حساب / کارت به کارت -->
    <div class="fCol jStart aStart inputHolder w50"
      v-if="payMethod.id === 4 || payMethod.id === 2">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: trackingCodeErr}">description</i>
        کد پیگیری</span>
      <div class="fRow jStart aCenter fullWidth inputWraper">
        <input
          class="transition-fast" placeholder="کد پیگیری"
          type="text" v-model="trackingCode">
      </div>
    </div>
    <!-- موعد چگ -->
    <div class="w25 fCol jStart aStart inputHolder"
      v-if="payMethod.id === 3">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: checkDateErr}">date_range</i>
        موعد چک</span>
      <div class="fRow jStart aCenter fullWidth inputWraper">
        <input :id="`checkDates${i}`"
          disabled
          class="transition-fast" placeholder="موعد چک"
          type="text" v-model="checkDateShow">
      </div>
    </div>
    <!--  شماره چک اختیاری برای پرداخت چکی -->
    <div class="fCol jStart aStart inputHolder w50"
      v-if="payMethod.id === 3">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: checkNumberErr}">description</i>
        شماره چک</span>
      <div class="fRow jStart aCenter fullWidth inputWraper">
        <input
          class="transition-fast" placeholder="شماره چک"
          type="text" v-model="checkNumber">
      </div>
    </div>
    <!--  وضعیت وصول چک برای پرداخت چکی -->
    <div class="fCol jStart aStart inputHolder w25"
      v-if="payMethod.id === 3">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: vosoolState === 0}">description</i>
        وضعیت وصول</span>
      <div class="fCol jCenter aStart fullWidth inputWraper"
        style="padding: 0px 0">
        <radio
          v-for="(item, index) in vosoolStates"
          v-bind:key="index"
          :simple="true"
          :data="item"
          style="padding-top: 8px"
          :selected="item.id === vosoolState"
          @click.native="vosoolState = item.id"/>
      </div>
    </div>
    <div class="fullWidth fRow jBetween aCenter">
      <div class="fCol jStart aStart inputHolder fullWidth">
        <span class="fRow jStart aCenter">
          <i class="material-icons-round"
            v-bind:class="{inpErr: payDescErr}">description</i>
          توضیحات</span>
        <div class="fRow jStart aCenter fullWidth inputWraper"
          style="margin-bottom: 0">
          <input
            class="transition-fast growFull" placeholder="توضیحات الزامی"
            type="text" v-model="payDesc">
          <div class="b fRow jStart aCenter"
            @click="clearPaymentForm"
            style="margin: 0 16px 0 0;">
            <i class="material-icons-round">delete</i>
            <label>پاک کردن فرم</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { CoolSelect } from 'vue-cool-select';
import Radio from '@/components/Radio.vue';
import moment from 'moment-jalaali';

export default {
  props: ['from', 'i', 'qestArray'],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      qests: [
        {
          id: '100',
          title: 'قسمت شماره یک',
          date: '2022-01-10T00:00',
          payed: true,
        },
        {
          id: '200',
          title: 'قسمت شماره دو',
          date: '2022-02-10T00:00',
          payed: false,
        },
        {
          id: '300',
          title: 'قسمت شماره سه',
          date: '2022-03-10T00:00',
          payed: false,
        },
        {
          id: '400',
          title: 'قسمت شماره چهار',
          date: '2022-04-10T00:00',
          payed: false,
        },
      ],
      selectedQest: '',
      payTypes: [
        {
          id: 2,
          title: 'سایر پرداخت‌ها',
        },
        {
          id: 1,
          title: 'پرداخت قسط',
        },
      ],
      payType: '',
      payMethods: [
        {
          id: 0,
          title: 'پوز',
        },
        {
          id: 1,
          title: 'نقدی',
        },
        {
          id: 2,
          title: 'پرداخت کارت به کارت',
        },
        {
          id: 4,
          title: 'حساب به حساب',
        },
        {
          id: 3,
          title: 'پرداخت چکی',
        },
      ],
      payMethod: '',
      payMethodErr: true,
      notPayed: false,
      payDate: '',
      payDateShow: '',
      payDateErr: true,
      payAmount: '',
      payAmountErr: true,
      payDesc: '',
      payDescErr: true,
      payAccounts: [],
      payAccount: '',
      payAccountErr: true,
      // optionals
      vosoolStates: [
        {
          id: 1,
          title: 'وصول شده',
        },
        {
          id: 2,
          title: 'وصول نشده',
        },
      ],
      // vosool state hamoon checkType too apie
      vosoolState: 0,
      vosoolStateErr: true,
      checkNumber: '',
      checkNumberErr: true,
      checkDate: '',
      checkDateShow: '',
      checkDateErr: true,
      depositor: '',
      depositorErr: true,
      lastFourDigits: '',
      lastFourDigitsErr: true,
      trackingCode: '',
      trackingCodeErr: true,
      noQest: false,
    };
  },
  components: {
    CoolSelect,
    Radio,
  },
  methods: {
    // format date
    formatDate(d) {
      return moment(d, 'YYYY-MM-DDTHH:mm:ss')
        .locale('fa')
        .format('dddd, jDD jMMMM jYYYY');
    },
    addNew() {
      this.$emit('addNew');
    },
    clearPaymentForm() {
      this.payAccount = '';
      this.payAccountErr = true;
      this.payMethod = '';
      this.payMethodErr = true;
      this.payAmount = '';
      this.payAmountErr = true;
      this.payDate = '';
      this.payDateErr = true;
      this.payDesc = '';
      this.payDescErr = true;
    },
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    selected(e, dropDown) {
      switch (dropDown) {
        case 'field': {
          this.dataChanged();
          // console.log(this.field.id);
          const a = this.field.id;
          if (a === 0 || a === 4 || a === 6) {
            this.plans = [
              {
                id: 1,
                title: 'A+ طرح طلایی',
              },
              {
                id: 2,
                title: 'A طرح طلایی',
              },
              {
                id: 3,
                title: 'B طرح نقره‌ای',
              },
              {
                id: 4,
                title: 'C طرح برنزی',
              },
            ];
          } else {
            this.plans = [
              {
                id: 2,
                title: 'A طرح طلایی',
              },
              {
                id: 3,
                title: 'B طرح نقره‌ای',
              },
              {
                id: 4,
                title: 'C طرح برنزی',
              },
            ];
          }
          this.fieldErr = false;
          this.plan = '';
          this.planErr = true;
          break;
        }
        case 'plan': {
          this.dataChanged();
          // console.log(this.plan.id);
          this.planErr = false;
          break;
        }
        case 'payMethod': {
          this.payMethodErr = false;
          this.payMethod = e;
          this.dataChanged();
          // if (this.payMethod.id === 4) {
          //   this.notPayed = true;
          //   this.payDate = '';
          // } else {
          //   this.notPayed = false;
          // }
          break;
        }
        case 'payAccount': {
          this.payAccountErr = false;
          this.dataChanged();
          // if (this.payMethod.id === 4) {
          //   this.notPayed = true;
          //   this.payDate = '';
          // } else {
          //   this.notPayed = false;
          // }
          break;
        }
        default:
          break;
      }
    },
    getAccounts() {
      this.accounts = [];
      this.payAccounts = [
        {
          id: -1,
          title: 'کمی صبر کنید...',
        },
      ];
      this.setMode('loading');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Financials/account`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.setMode('loaded');
        if (response.data.isSuccess) {
          this.accounts = response.data.data;
          this.payAccounts = [];
          for (let i = 0; i < this.accounts.length; i += 1) {
            const a = {
              id: this.accounts[i].id,
              title: this.accounts[i].name,
              bank: this.accounts[i].bank,
            };
            this.payAccounts.push(a);
          }
          // console.log(this.payAccounts);
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.setMode('error', this.errorHandler(error));
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch((error) => {
        this.errorHandler(error);
        this.setMode('error');
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    commaSep(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    dataChanged() {
      this.$emit('payItemChanged', {
        index: this.i,
        ready: this.isNewPaymentReady,
      });
      if (this.isNewPaymentReady) {
        this.$emit('result', this.finalPayData);
      } else {
        this.$emit('delete', this.i);
      }
    },
  },
  computed: {
    isNewPaymentReady() {
      const t = this.payType;
      let shart = false;
      switch (t) {
        case 1: {
          shart = !this.payDescErr
            && !this.payAmountErr
            && !this.payDateErr
            && !this.payAccountErr
            && !this.payMethodErr
            && !this.selectedQestErr;
          break;
        } case 2: {
          shart = !this.payDescErr
            && !this.payAmountErr
            && !this.payDateErr
            && !this.payAccountErr
            && !this.payMethodErr;
          break;
        }
        default:
          break;
      }
      if (this.payMethod.id === 3) {
        const ch = !this.vosoolStateErr
          && !this.checkNumberErr
          && !this.checkDateErr;
        shart = shart && ch;
      }
      return shart;
    },
    finalPayData() {
      const a = {
        index: this.i,
        installmentId: this.selectedQest,
        accountId: this.payAccount.id,
        type: this.payMethod.title,
        amount: this.payAmount.replace(/,/g, ''),
        date: this.payDate,
        description: this.payDesc,
        trackingCode: this.trackingCode,
        depositor: this.depositor,
        checkNumber: this.checkNumber,
        checkType: this.vosoolState,
        checkDate: this.checkDate,
      };
      return a;
    },
  },
  mounted() {
    this.getAccounts();
    if (this.from === 'assignment') {
      this.payType = 2;
      this.noQest = true;
    }
    if (this.from !== 'assignment' && this.qestArray.length === 0) {
      this.payType = 2;
      this.noQest = true;
      this.qests = this.qestArray;
    } else {
      this.qests = this.qestArray;
    }
  },
  watch: {
    payType() {
      this.selectedQest = '';
      this.dataChanged();
    },
    payDate() {
      if (this.payDate !== '') {
        // console.log('date', this.payDate);
        this.payDateShow = moment(this.payDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY، ساعت HH:mm');
        this.payDateErr = false;
      } else {
        this.payDateErr = true;
        this.payDateShow = '';
      }
      this.dataChanged();
    },
    checkDate() {
      if (this.checkDate !== '') {
        // console.log('date', this.payDate);
        this.checkDateShow = moment(this.checkDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.checkDateErr = false;
      } else {
        this.checkDateErr = true;
        this.checkDateShow = '';
      }
      this.dataChanged();
    },
    payDesc() {
      if (this.payDesc.length === 0) {
        this.payDescErr = true;
      } else if (this.payDesc.length > 128) {
        this.payDesc = this.payDesc.substr(0, 128);
        this.payDescErr = false;
      } else {
        this.payDescErr = false;
      }
      this.dataChanged();
    },
    payAmount() {
      let p = this.payAmount;
      p = p.replace(/,/g, '');
      if (!/^\d+$/.test(p) || (p.charAt(0) === '0' || p.charAt(0) === 0)) {
        p = p.substr(0, p.length - 1);
      }
      if (p.length > 12) {
        this.payAmount = this.payAmount.substr(0, 12);
      }
      p = this.commaSep(p);
      this.payAmount = p;
      if (this.payAmount.length > 3) {
        this.payAmountErr = false;
      } else {
        this.payAmountErr = true;
      }
      this.dataChanged();
    },
    isNewPaymentReady() {
      this.dataChanged();
    },
    vosoolState() {
      this.vosoolStateErr = this.vosoolState === 0;
      this.dataChanged();
    },
    checkNumber() {
      this.checkNumberErr = this.checkNumber.length < 1;
      this.dataChanged();
    },
    depositor() {
      this.checkNumberErr = this.checkNumber.length < 1;
      this.dataChanged();
    },
    trackingCode() {
      this.trackingCodeErr = this.trackingCode.length < 1;
      this.dataChanged();
    },
    selectedQest() {
      this.selectedQestErr = this.selectedQest === '';
      this.dataChanged();
    },
  },
};
</script>

<style lang="scss" scoped>
.formSection {
  padding: 16px;
  .uploadersHolder h3, .videoList h3 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 16px;
    font-weight: 400;
  }
  .uploadersHolder h4, .videoList h4 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 14px;
    font-weight: 200;
    position: relative;
  }
  .uploadersHolder h4::before, .videoList h4::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: royalblue;
    left: calc(100% - 8px);
    top: 50%;
    transform: translateY(-50%);
  }
  .uploadersHolder p, .videoList p {
    width: 100%;
    text-align: right;
    padding: 0px 16px;
    word-spacing: -1px;
    font-size: 12px;
    font-weight: 200;
    margin: 0 0 4px 0;
    position: relative;
  }
  .uploadersHolder p::before, .videoList p::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: rgba(65, 105, 225, 0.301);
    left: calc(100% - 8px);
    top: 5px;
  }
}
.done {
  border-color: rgba($color: green, $alpha: 0.45) !important;
}
.ti {
  text-align: right;
  font-size: 14px;
  padding-right: 16px;
  margin-bottom: 16px;
  margin-top: 16px;
  border-right: solid 4px rgba($color: #000000, $alpha: 0.5);
}
.qests {
  margin-bottom: 32px;
  .qest {
    padding: 8px;
    border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.15);
    background-color: rgba($color: #000000, $alpha: 0.0);
    .ind {
      font-size: 10px;
      min-width: 24px;
      text-align: right;
    }
    .amount {
      min-width: 112px;
      margin-left: 16px;
      padding-left: 16px;
      border-left: dashed 1px rgba($color: #000000, $alpha: 0.15);
      span.a {
        font-size: 18px;
        padding: 4px 8px;
        border-radius: 16px;
        background-color: rgba($color: #000000, $alpha: 0.15);
        line-height: 1;
        font-weight: bold;
        text-align: right;
      }
      .unit {
        font-size: 10px;
        font-weight: 200;
        margin-right: 8px;
      }
    }
    .qestTitle {
      font-size: 14px;
      font-weight: bold;
      text-align: right;
      margin-left: 16px;
    }
    .qestDate {
      font-size: 10px;
      text-align: right;
    }
    .qestState {
      padding: 2px 8px;
      border-radius: 24px;
      background-color: rgba($color: #000000, $alpha: 0.15);
      font-size: 10px;
      font-weight: bold;
      color: #131313;
    }
  }
  .qest.selected {
    background-color: rgba($color: #000000, $alpha: 0.05);
  }
}
</style>
